__webpack_require__.p = "/skills-honing-2022/";